/*
  Overlook free-shipping progress bar.
  Shows "You're $X away from free shipping" with a progress line at the top of the cart drawer
  and the cart page, and "You've unlocked free shipping" once the cart reaches the threshold.
  The fill line carries display:block inline because the theme hides empty divs.
  The threshold comes from window.OVERLOOK_FREE_SHIPPING_CENTS (set in snippets/meta-tags.liquid).
*/
(() => {
  if (window.__overlookFsb) return;
  window.__overlookFsb = true;

  const threshold = () => Number(window.OVERLOOK_FREE_SHIPPING_CENTS) || 4000;
  const money = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
  };

  const targets = () => {
    const list = [];
    const drawerInner = document.querySelector('cart-drawer .drawer__inner');
    if (drawerInner) list.push({ parent: drawerInner, after: drawerInner.querySelector('.drawer__header') });
    const cartPage = document.querySelector('cart-items');
    if (cartPage && !cartPage.closest('cart-drawer')) list.push({ parent: cartPage.parentElement, before: cartPage });
    return list;
  };

  const build = () => {
    const el = document.createElement('div');
    el.className = 'fsb';
    el.innerHTML = '<p class="fsb__text" role="status" aria-live="polite"></p><div class="fsb__track" aria-hidden="true"><div class="fsb__fill" style="display:block"></div></div>';
    return el;
  };

  let busy = false;
  const render = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await fetch(`${(window.routes && routes.cart_url) || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      targets().forEach((t) => {
        let el = t.parent.querySelector(':scope > .fsb');
        if (!cart.item_count) { if (el) el.remove(); return; }
        if (!el) {
          el = build();
          if (t.after) t.after.insertAdjacentElement('afterend', el);
          else t.parent.insertBefore(el, t.before);
        }
        const goal = threshold();
        const remaining = Math.max(0, goal - cart.total_price);
        el.classList.toggle('is-complete', remaining === 0);
        el.querySelector('.fsb__text').textContent = remaining === 0
          ? "You've unlocked free shipping"
          : `You're ${money(remaining)} away from free shipping`;
        el.querySelector('.fsb__fill').style.width = `${Math.min(100, (cart.total_price / goal) * 100)}%`;
      });
    } catch (e) {
      /* leave the cart as it is */
    } finally {
      busy = false;
    }
  };

  let timer;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(render, 150); };

  const start = () => {
    render();
    // Re-check only when the cart itself changes: the drawer, the cart page list, or the cart icon count.
    const observer = new MutationObserver((records) => {
      const relevant = records.some((r) => !(r.target.closest && r.target.closest('.fsb')));
      if (relevant) schedule();
    });
    document.querySelectorAll('cart-drawer, cart-items, #cart-icon-bubble').forEach((el) =>
      observer.observe(el, { childList: true, subtree: true })
    );
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
